import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { ratgeber } from '../data/stadtteile';
import { allRatgeberContent } from '../data/allRatgeberContent';

const RatgeberArticle = () => {
  // Extract slug from URL path
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const slug = pathSegments[pathSegments.length - 1];
  
  const article = ratgeber.find(r => r.slug === slug);
  const detailedContent = allRatgeberContent[slug];
  
  if (!article) {
    return <div className="container mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-4">Artikel nicht gefunden</h1>
      <p>Der gesuchte Ratgeber-Artikel existiert nicht.</p>
      <Link to="/ratgeber" className="text-orange-600 hover:underline">Zurück zur Ratgeber-Übersicht</Link>
    </div>;
  }
  
  return (
    <>
      <Helmet>
        <title>{article.title} – Ratgeber | Schlüsseldienst Dortmund</title>
        <meta name="description" content={article.excerpt} />
        <link rel="canonical" href={`https://schluesseldienst.services/ratgeber/${slug}/`} />
      </Helmet>
      
      <div className="container mx-auto px-4 py-12">
        <Breadcrumbs items={[
          { label: 'Ratgeber', link: '/ratgeber/' },
          { label: article.title }
        ]} />
        
        <article className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6 text-gray-900">{article.title}</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">{article.excerpt}</p>
            
            <div className="bg-orange-50 border-l-4 border-orange-600 p-6 mb-8 rounded-r">
              <p className="text-sm text-gray-700">
                <strong>Hinweis:</strong> Dieser Ratgeber dient zur Information. Bei Fragen oder Problemen 
                wenden Sie sich gerne an unsere Experten unter <strong>0231 39085116</strong>.
              </p>
            </div>
            
            {/* Render detailed content if available */}
            {detailedContent && detailedContent.sections ? (
              detailedContent.sections.map((section, index) => (
                <div key={index} className="mb-12">
                  <h2 className="text-3xl font-bold mb-4 text-gray-900 mt-8">{section.title}</h2>
                  <div className="text-gray-700 leading-relaxed whitespace-pre-line">
                    {section.content}
                  </div>
                </div>
              ))
            ) : (
              // Fallback content if detailed content not available
              <>
                <h2 className="text-3xl font-bold mb-4 mt-8">Überblick</h2>
                <p className="text-gray-700 leading-relaxed">
                  In diesem Ratgeber erfahren Sie alles Wichtige zum Thema "{article.title}". 
                  Unsere Experten haben die wichtigsten Informationen für Sie zusammengestellt.
                </p>
                
                <p className="text-gray-700 leading-relaxed">
                  Für weitere Fragen oder eine persönliche Beratung stehen wir Ihnen jederzeit 
                  telefonisch unter 0231 39085116 zur Verfügung.
                </p>
              </>
            )}
            
            <div className="bg-gradient-to-br from-orange-600 to-amber-500 text-white rounded-2xl p-8 my-12 text-center shadow-xl">
              <h2 className="text-3xl font-bold mb-4">Brauchen Sie Hilfe?</h2>
              <p className="text-lg mb-6">Unser Team steht Ihnen jederzeit zur Verfügung!</p>
              <a
                href="tel:+4923139085116"
                className="inline-block bg-white text-orange-600 px-8 py-4 rounded-full text-xl font-bold hover:bg-gray-100 transition-all shadow-lg"
              >
                📞 0231 39085116
              </a>
            </div>
            
            <h2 className="text-3xl font-bold mb-4 mt-12">Weiterführende Informationen</h2>
            <div className="bg-gray-50 rounded-lg p-6">
              <ul className="space-y-3">
                <li>
                  <Link to="/preise" className="text-orange-600 hover:text-orange-700 font-semibold hover:underline">
                    → Unsere transparenten Festpreise
                  </Link>
                </li>
                <li>
                  <Link to="/einsatzgebiete" className="text-orange-600 hover:text-orange-700 font-semibold hover:underline">
                    → Alle Einsatzgebiete in Dortmund
                  </Link>
                </li>
                <li>
                  <Link to="/ratgeber" className="text-orange-600 hover:text-orange-700 font-semibold hover:underline">
                    → Weitere hilfreiche Ratgeber
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </article>
      </div>
    </>
  );
};

export default RatgeberArticle;
